var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionDataWrapper',{staticClass:"gallery-section",attrs:{"sectionSlug":"gallery"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('Section',{class:_vm.className},[_c('h2',{domProps:{"innerHTML":_vm._s(slotProps.title)}}),_c('GalleryDataWrapper'),_c('div',{domProps:{"innerHTML":_vm._s(slotProps.content)}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }